
















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { INameAndValue } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'GithubIntegrationAccordion',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    githubIntegration: {
      type: Array as () => INameAndValue[],
      required: true,
    },
  },

  computed: {
    itemName(): string {
      return TextAssistant.itemSingularName(this.type).toLowerCase()
    },
    itemNamePlural(): string {
      return TextAssistant.itemPluralName(this.type).toLowerCase()
    },
  },
})
